import React from "react";
import paymentInThread from "venuescanner-js/react/components/Inbox/helpers/paymentInThread";
import AutomatedMessageText from "../../AutomatedMessageText";

const AutomatedMessagePaymentEnquiry = ({
  thread,
  message,
  children,
  cumulative,
}) => {
  // console.log({ totalPaidInPence, outstanding, priceInPence })
  if (!isEventFullyPaid(thread, message, cumulative)) return null;

  return children ? (
    <AutomatedMessageText tagTitle="Payment">{children}</AutomatedMessageText>
  ) : null;
};

function isEventFullyPaid(thread, message, cumulative) {
  const payment = paymentInThread({ thread, paymentID: message.payment });

  if (!payment) return false;

  return cumulative.outstanding - payment.amountInPence / 100 <= 0;
}

export default AutomatedMessagePaymentEnquiry;
